import React, { Component} from 'react'
import { observer } from 'mobx-react'
import Store from '../../store/ProductionTableStore'
import { secsToHHMM } from '../../../../helpers'
import { toJS } from 'mobx'

@observer
class TableHeader extends Component {    
    render() {
        const {
            title,
            subTitle,
            searchTitle,
            day
        } = this.props
        let dayTitle = null
        let dateTitle = null
        let titleClasses = ''
        let tableHeader = null
        let totalPerformedTime = null

        if (!searchTitle) {
            if (title) {
                dayTitle = title
            }
    
            if (subTitle) {
                dateTitle = <span className="table__header__day__item--date">{ subTitle }</span>
            }
        } else {
            if (Store.FilterArticleSummary.amount) {
                dayTitle = `${ searchTitle } (${ Store.FilterArticleSummary.amount } ${ Store.FilterArticleSummary.unit })`
            } else {
                dayTitle = searchTitle
            }
            
            titleClasses = 'table__header__day__item--nocapitalize'
        }

        if (day) {
            if (day.today) {
                totalPerformedTime = `Utförd tid idag: ${ secsToHHMM(Store.totalCompletedTimeToday) }`
            }

            if (day.summary) {
                tableHeader = <div className="table__row table__row--header-summation">
                    <div
                        className={ `table__row__cell table__row__cell__arrow table__row__cell__arrow--top ${ day.openDayBar ? 'table__row__cell__arrow--open' : '' }` }
                        onClick={ day ? Store.HANDLE_TOGGLE_DAY.bind(this, day) : null }
                    >                    
                    </div>
                    <div className="table__row__cell">Kalkylnr.</div>
                    <div className="table__row__cell table__row__cell--lg">Benämning</div>
                    <div className="table__row__cell table__row__cell--md">Kund</div>
                    <div className="table__row__cell">Prod. datum</div>
                    <div className="table__row__cell">Lev. datum</div>
                    <div className="table__row__cell">Leveranssätt</div>
                    <div className="table__row__cell">Säljare</div>
                    <div className="table__row__cell table__row__cell--sm table__row__cell--right">
                        Antal
                        <span title="Total" className="table__header__list__cell__total">
                            { day.summary.orders }
                        </span>
                    </div>
                    <div className="table__row__cell table__row__cell--right">
                        Ordervärde
                        <span title="Total" className="table__list__cell__total">{ day.summary.value }</span>
                    </div>
                    <div className="table__row__cell table__row__cell--right" title="Produktionstid - TIM/MIN">
                        Prod. Tid
                        <span title="Total - TIM/MIN" className="table__list__cell__total">{ day.summary.productionTime }</span>
                    </div>
                    <div className="table__row__cell table__row__cell--right" title="Resterande tid - TIM/MIN">
                        Rest. Tid
                        <span title="Total - TIM/MIN" className="table__list__cell__total">{ day.summary.remainingTime }</span>
                    </div>
                    <div className="table__row__cell table__row__cell--right">
                        Kvar
                        <span title="Total" className="table__list__cell__total">{ day.summary.totalPercentile.toFixed(0) }%</span>
                    </div>
                </div>
            } else {
                tableHeader = <div className="table__row table__row--header">
                    <div
                        className={ `table__row__cell table__row__cell__icon table__row__cell__icon--top table__row__cell__icon--arrow ${ day.openDayBar ? 'table__row__cell__icon--arrow-open' : '' }` }
                        onClick={ day ? Store.HANDLE_TOGGLE_DAY.bind(this, day) : null }
                    >                    
                    </div>
                    <div className="table__row__cell">Kalkylnr.</div>
                    <div className="table__row__cell table__row__cell--tiny">&nbsp;</div>
                    <div className="table__row__cell table__row__cell--lg">Benämning</div>
                    <div className="table__row__cell table__row__cell--md">Kund</div>
                    <div className="table__row__cell">Prod. datum</div>
                    <div className="table__row__cell">Lev. datum</div>
                    <div className="table__row__cell">Leveranssätt</div>
                    <div className="table__row__cell">Säljare</div>
                    <div className="table__row__cell table__row__cell--sm table__row__cell--right">Antal</div>
                    <div className="table__row__cell table__row__cell--right">Ordervärde</div>
                    <div className="table__row__cell table__row__cell--right" title="Produktionstid - TIM/MIN">Prod. Tid</div>
                    <div className="table__row__cell table__row__cell--right" title="Resterande tid - TIM/MIN">Rest. Tid</div>
                    <div className="table__row__cell table__row__cell--right">Avdelning</div>
                    <div className="table__row__cell table__row__cell--right">Kvar</div>
                </div>
            }
        }

        return <div className="table__header">
            <div className="table__header__day">
                <div className="table__header__day--left">
                    <h2 className={ `table__header__day__item ${ titleClasses }` }>
                        { dayTitle }
                        { dateTitle }
                    </h2>
                </div>
                <div className="table__header__day--right">
                    <span className="table__header__day__item table__header__day__item--small">
                        { totalPerformedTime }
                    </span>
                </div>                
            </div>

            { tableHeader }                  
        </div>
    }
}

export default TableHeader
